var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.StoreExists == false)?_c('div',[_vm._t("default")],2):_c('div',[_c('error-state')],1)}
var staticRenderFns = []

export { render, staticRenderFns }